Object.defineProperty(exports, "__esModule", {
  value: true
});

// Customizable Area Start
exports.validationApiContentType = "application/json";
exports.validationApiMethodType = "GET";
exports.exampleAPiEndPoint = "EXAMPLE_URL";
exports.exampleAPiMethod = "POST";
exports.exampleApiContentType = "application/json";
exports.textInputPlaceHolder = "Enter Text";
exports.labelTitleText = "Share";
exports.labelBodyText = "Share Body";

exports.btnShareTitle = "Share Builder.ai";
exports.url="https://www.builder.ai/"
exports.quote="We make software so easy, everyone can do it"
exports.hashtag="#builderai"

exports.share ="Share";
exports.copy = "Copy Link";
exports.bookmark="Bookmark";
exports.shareVia="Share via..";
exports.whatsapp="WhatsApp";
exports.x="X";
exports.facebook="Facebook";
exports.instagram="Instagram";
exports.messages="Messages";
exports.email="Email"
// Customizable Area End